<template>
  <div class="animated fadeIn">
    <MainChartTable :set_data=set_data :selectedData=ecpm />
  </div>
</template>
<script>
import MainChartTable from '../MainChartTable'
export default {
    name: 'Ecpm',
    props:[ 'setData'],
    components:{
        MainChartTable
    },
    data () {
        return {
            set_data:0,
            ecpm:'ecpms',
        }
    },
    watch :{
        setData(nValue,oValue){
            this.set_data++
            this.ecpm='ecpms'
        }
    }
}
</script>
